module.exports = __webpack_public_path__ + "static/fonts/notokr-regular.a288961.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/relayevent/font/notokr-regular.woff2
// module id = V3ac
// module chunks = 0